const getOrderTransferDescription = (
  showName: string,
  companyName: string,
  standName: string
) => `FFAIR Ltd, ${showName},  ${companyName}, ${standName}`;

export default getOrderTransferDescription;
